var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 47,
    viewBox: "0 0 64 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 7.68023C63.9923 6.30144 63.6104 4.95059 62.8948 3.77197L40.3071 23.3581L63.4644 42.0098C63.8125 41.1323 63.9941 40.1976 63.9999 39.2535V7.68023Z",
    fill: "#35A684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9997 24.9109L59.7564 0.853332C58.694 0.302204 57.5164 0.00982188 56.3196 0H7.6797C6.48 0.00847812 5.29935 0.300899 4.23438 0.853332L31.9997 24.9109Z",
    fill: "#35A684"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.03 26.1976L33.4034 29.3464C33.0155 29.6826 32.5194 29.8677 32.006 29.8677C31.4927 29.8677 30.9966 29.6826 30.6087 29.3464L26.9671 26.1912L2.98633 45.2738C4.32036 46.3377 5.97335 46.9223 7.67965 46.9335H56.3196C57.9658 46.9286 59.566 46.3904 60.8806 45.3997L37.03 26.1976Z",
    fill: "#35A684"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.10506 3.78027C0.391015 4.95641 0.00911954 6.30411 0 7.68V39.2533C0.00976455 40.1275 0.169971 40.9935 0.473599 41.8133L23.68 23.3472L1.10506 3.78027Z",
    fill: "#35A684"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.40ccf185.svg";
export { ForwardRef as ReactComponent };